/**
 * Panel del **historial de consumo** del inventario de la sede activa.
 *
 * Presentacional: recibe la lista `hist` del payload de `GET /inventario/rollos`
 * (150 últimos) y la pinta como tabla (referencia, consumo, usuario, fecha).
 * Réplica de la vista de historial del SSR (`inventario.html`), pero sobre la API
 * REST. Sin lógica de negocio ni acceso a la red.
 */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@/components/ui";

import { consumoEntryText } from "../format";
import type { HistorialEntry } from "../types";

interface HistorialPanelProps {
  hist: HistorialEntry[];
}

export function HistorialPanel({ hist }: HistorialPanelProps) {
  if (hist.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-slate-500">
        Aún no hay consumos registrados en esta sede.
      </p>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Referencia</TableHeaderCell>
          <TableHeaderCell>Consumo</TableHeaderCell>
          <TableHeaderCell>Usuario</TableHeaderCell>
          <TableHeaderCell>Fecha</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {hist.map((entry) => (
          <TableRow key={entry.id}>
            <TableCell className="font-medium text-slate-800">
              {entry.desc || (entry.tipo === "galv" ? "Galvanizada" : "Acero")}
            </TableCell>
            <TableCell>{consumoEntryText(entry)}</TableCell>
            <TableCell>{entry.usuario || "—"}</TableCell>
            <TableCell className="text-slate-500">{entry.fecha || "—"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
